'use es6';

import getIn from 'transmute/getIn';
export const isWidgetNearTheTop = widget => getIn(['layout', 'y'], widget) <= 1;